export default __webpack_public_path__ + "static/media/seal.68f6b6b7.svg";